import type { Resource } from '../../';
export const country_countries_CN: Resource = {"default":"China"};
